import React from 'react';
import PropTypes from 'prop-types';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RCEHelpersPropTypes = {
  rce: PropTypes.shape({
    isViewMode: PropTypes.bool.isRequired,
    setInPluginEditingMode: PropTypes.func,
    helpers: PropTypes.shape({
      handleFileUpload: PropTypes.func
    }),
    getSiteMembers: PropTypes.func
  }).isRequired,
  t: PropTypes.func.isRequired,
  layout: PropTypes.object.isRequired,
  design: PropTypes.object.isRequired
};
const RCEHelpersContext = React.createContext({});
const withRCEHelpers = (WrappedComponent) => (props) => {
  return /* @__PURE__ */ React.createElement(RCEHelpersContext.Consumer, null, (_a) => {
    var _b = _a, { layout, design, t } = _b, rest = __objRest(_b, ["layout", "design", "t"]);
    return /* @__PURE__ */ React.createElement(WrappedComponent, __spreadProps(__spreadValues({}, props), { rce: rest, t, layout, design }));
  });
};

export { RCEHelpersContext, RCEHelpersPropTypes, withRCEHelpers };
//# sourceMappingURL=index.js.map
